export type ContractType = 'new' | 'current';

export interface ContractFormData {
	// Shared fields (both new and current clients)
	customerName: string;
	customerTitle: string;
	customerEmail: string;
	customerAddress: string;
	companyName: string;
	repFirstName: string;
	repLastName: string;
	managerEmail: string;
	urgency: string;
	hipaaCompliance: boolean;
	additionalNotes?: string;

	// Current client specific fields
	adminLink?: string;
	currentLevitatePlan?: string; // What plan the client currently has with Levitate
	renewalDate?: string;
	monthsLeft?: number;
	billingCycle?: string; // Annual or Quarterly
	contractTypeValue?: string; // The actual contract type like "Website Upgrade"
	totalPriceDueToday?: number; // Total price due today
	totalPriceUponRenewal?: number; // Total price upon renewal (core + website)
	discountBreakdown?: number; // Discount amount for current clients
	fbAdsChecked?: boolean;
	fbPremiumChecked?: boolean;
	gLSAChecked?: boolean;
	customContentChecked?: boolean;
	customContentNonprofitChecked?: boolean;
	handwritten?: boolean;
	pendingCancel?: string;
}

export interface ContractGenerationResponse {
	success: boolean;
	slideUrl?: string;
	fileId?: string;
	fileName?: string;
	pdfUrl?: string;
	error?: string;
}

export const MANAGER_OPTIONS = [
	{ email: 'casey.brady@levitateapp.com', name: 'Casey Brady' },
	{ email: 'connor.kulasingam@levitateapp.com', name: 'Connor Kulasingam' },
	{ email: 'ethan.deal@levitateapp.com', name: 'Ethan Deal' },
	{ email: 'ivan.tomich@levitateapp.com', name: 'Ivan Tomich' },
	{ email: 'nick.cristinziano@levitateapp.com', name: 'Nick Cristinziano' },
	{ email: 'wade.naziri@levitateapp.com', name: 'Wade Naziri' },
	{ email: 'maggie.robertson@levitateapp.com', name: 'Maggie Robertson' },
] as const;

export const CURRENT_PLAN_OPTIONS = [
	{ value: '$150 - Business Plus', label: '$150 - Business Plus' },
	{ value: '$199 - Business Silver', label: '$199 - Business Silver' },
	{ value: '$249 - Business Gold', label: '$249 - Business Gold' },
	{ value: '$299 - Client Happiness Platform', label: '$299 - Client Happiness Platform' },
	{ value: '$349 - Client Happiness Platform w/ AI', label: '$349 - Client Happiness Platform w/ AI' },
	{ value: '$399 - Client Happiness Advanced', label: '$399 - Client Happiness Advanced' },
	{ value: '$299 - Website Essential Standalone', label: '$299 - Website Essential Standalone' },
	{ value: '$349 - Website Preferred Standalone', label: '$349 - Website Preferred Standalone' },
	{ value: '$399 - Website Prestige Standalone', label: '$399 - Website Prestige Standalone' },
] as const;

export const CONTRACT_TYPE_OPTIONS = [
	{ value: '$249 Website Essential Upgrade', label: '$249 Website Essential Upgrade' },
	{ value: '$299 Website Preferred Upgrade', label: '$299 Website Preferred Upgrade' },
	{ value: '$349 Website Prestige Upgrade', label: '$349 Website Prestige Upgrade' },
	{ value: 'High Risk Save', label: 'High Risk Save' },
	{ value: 'Pending Cancel Save', label: 'Pending Cancel Save' },
	{ value: 'Standalone Website', label: 'Standalone Website' },
	{ value: 'Non-website', label: 'Non-website' },
	{ value: 'Add-on only', label: 'Add-on only' },
] as const;

export const WEBSITE_UPGRADE_OPTIONS = [
	{ value: '$249 Website Essential Upgrade', label: '$249 Website Essential Upgrade' },
	{ value: '$299 Website Preferred Upgrade', label: '$299 Website Preferred Upgrade' },
	{ value: '$349 Website Prestige Upgrade', label: '$349 Website Prestige Upgrade' },
] as const;

export const URGENCY_OPTIONS = [
	{ value: 'Send to prospect immediately', label: 'Send to prospect immediately' },
	{
		value: 'Hold until we hear from you/manager to send to prospect',
		label: 'Hold until we hear from you/manager to send to prospect',
	},
] as const;
